import GameSelectAll from "./GameSelectAll";

export default GameSelectAll;